export default "__VITE_ASSET__2d20a61d__"